import { render } from "./OpenedInvoices.vue?vue&type=template&id=4a86a718&ts=true"
import script from "./OpenedInvoices.vue?vue&type=script&lang=ts"
export * from "./OpenedInvoices.vue?vue&type=script&lang=ts"

import "./OpenedInvoices.vue?vue&type=style&index=0&id=4a86a718&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__